import {i18n} from "@/plugins/i18n";
import {allotmentStatus} from "@/constants/AllotmentStatus";
import {openBankingRequestsStatus} from "@/constants/openBanking";

export const bankTransferTransaction = {
    PENDING: 1,
    SUCCESS: 2,
    FAILED: 3,
    SETTLEMENT_PENDING: 4,
    UNKNOWN_YET: 5,
    CANCELED: 6,
    REVERSAL: 7,
}

export const bankTransferTransactionStr = {
    PENDING: i18n.t('label.pending'),
    SUCCESS: i18n.t('label.success'),
    FAILED: i18n.t('label.failed'),
    SETTLEMENT_PENDING: i18n.t('transaction.status.settlement_pending'),
    UNKNOWN_YET: i18n.t('transaction.status.unknown_yet'),
    CANCELED: i18n.t('transaction.status.canceled'),
    REVERSAL: i18n.t('transaction.status.reversal'),

    get(status) {
        let status_str = null;

        Object.keys(bankTransferTransaction).forEach(item => {
            if (bankTransferTransaction[item] === status) {
                status_str = bankTransferTransactionStr[item];
            }
        });

        return status_str;
    }
}

export const bankTransferTransactionVariant = (status) => {
    if (status === bankTransferTransaction.PENDING) {
        return 'badge-warning';
    }

    if (status === bankTransferTransaction.SUCCESS) {
        return 'badge-success';
    }

    if (status === bankTransferTransaction.FAILED) {
        return 'badge-danger';
    }
    if (status === bankTransferTransaction.CANCELED) {
        return 'badge-danger';
    }

    if (status === bankTransferTransaction.SETTLEMENT_PENDING ||
        status === bankTransferTransaction.REVERSAL) {
        return 'badge-orange';
    }

    if (status === bankTransferTransaction.UNKNOWN_YET) {
        return 'badge-dark';
    }

    return 'badge-secondary';
};

export const bankTransferTransactionType = {
    INTERNAL: 1,
    PAYA: 2,
    SATNA: 3,
}
export const bankTransferTransactionTypeStr = {
    INTERNAL: i18n.t('label.internal'),
    PAYA: i18n.t('label.paya'),
    SATNA: i18n.t('label.satna'),

    get(type) {
        let type_str = null;

        Object.keys(bankTransferTransactionType).forEach(item => {
            if (bankTransferTransactionType[item] === type) {
                type_str = bankTransferTransactionTypeStr[item];
            }
        });

        return type_str;
    }
}

export const transactionType = {
    NORMAL_WITHDRAW: 1,
    REFUND: 2,
}
export const transactionTypeStr = {
    NORMAL_WITHDRAW: i18n.t('open_banking.transactions.transaction_types.normal_withdraw'),
    REFUND: i18n.t('open_banking.transactions.transaction_types.refund'),

    get(type) {
        let type_str = null;

        Object.keys(transactionType).forEach(item => {
            if (transactionType[item] === type) {
                type_str = transactionTypeStr[item];
            }
        });

        return type_str;
    }
}